























import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { loginModule } from '@/store/authentication/login';
import { tokenModule } from '@/store/authentication/authentication';
import { viewEditingStateModule } from '@/store/state/viewEditingState';

import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';

@Component({
  components: {
    ConfirmDialog,
    NormalButton,
  },
  filters: {
    clockFormat(value: Date): string {
      moment.locale('ja');
      return moment(value).format('YYYY/MM/DD(ddd) HH:mm:ss');
    },
  },
})
export default class Header extends Vue {
  private isLogon: boolean = false;
  private clock: Date = new Date();

  @Watch('$route')
  public routeUpdate() {
    this.initialize();
  }

  public created(): void {
    if (this.isLogon) {
      loginModule.取得する();
    }
    this.initialize();
  }

  private async initialize(): Promise<void> {
    document.title = this.fullTitle();
    this.isLogon = this.$router.currentRoute.meta.requiresAuth;
    this.updateClock();
  }

  private title(): string {
    return this.$router.currentRoute.meta.title;
  }

  private fullTitle(): string {
    if (!this.title()) {
      return 'PROGOS3';
    }
    return 'PROGOS3 | ' + this.title();
  }

  private updateClock(): void {
    setInterval(() => {
      this.clock = new Date();
    }, 1000); // 1s に一度更新する
  }

  get 部署表示名(): string {
      if (loginModule.マスターである) {
        return '';
      }
      return '部署名: ' + this.部署名;
  }

  get 部署名(): string {
    return loginModule.部署名を取得する;
  }

  get 氏名(): string {
    return loginModule.氏名を取得する;
  }

  get 画面を編集中である(): boolean {
    return viewEditingStateModule.画面を編集中である;
  }

  private 確認ダイアログを表示する(): void {
    this.$modal.show('ログアウト確認ダイアログ');
  }

  private 確認ダイアログを閉じる(): void {
    this.$modal.hide('ログアウト確認ダイアログ');
  }

  private メッセージ(): string {
    if (viewEditingStateModule.画面を編集中である) {
      return '編集中のデータは破棄されますが、よろしいですか？';
    }
    return 'ログアウトします。よろしいですか？';
  }

  private ログアウトする(): void {
    tokenModule.削除する();
    loginModule.クリアする();
    viewEditingStateModule.初期化する();
    this.確認ダイアログを閉じる();
    this.$router.push({ path: '/logon' });
  }
}
